import { IPeopleGuiModel, IPeoplePutGuiModel } from "../model/IPeopleGuiModel";
import PeopleService from "../service/PeopleService";
import { IPeopleModel } from "../service/model/IPeopleModel";
import { BusinessLogicDefaultResult, BusinessLogicResult } from "./BusinessLogicResult";

export default class PeopleBusinessLogic {
    public async getPeople(
        organizationId: string
    ): Promise<BusinessLogicResult<IPeopleGuiModel[]>> {

        const service = new PeopleService();
        const result = await service.getPeople(organizationId);

        if (result.hasErrors) {
            return new BusinessLogicResult([], result.errors);
        } else {
            let apiData: IPeopleGuiModel[] = result.value;
            return new BusinessLogicResult(apiData, result.errors);
        }
    }
    public async postPeople(
        organizationId: string, firstName: string, lastName: string, userId: string
    ): Promise<BusinessLogicDefaultResult> {

        const service = new PeopleService();

        const result = await service.postPeople(organizationId, firstName, lastName, userId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }

    }
    public async putPeople(
        organizationId: string, id: number, data: IPeoplePutGuiModel
    ): Promise<BusinessLogicDefaultResult> {

        const service = new PeopleService();

        const result = await service.putPeople(organizationId, id, data);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }

    }
}